import { ContentLayout, Header } from "@amzn/awsui-components-react";
import { FC } from "react";
import Layout from "../../layout/Layout";

const StylesheetColors: FC<any> = () => {
    return (
        <Layout>
            <ContentLayout header={<Header variant="h1">Colors</Header>}>
                <>Colors</>
            </ContentLayout>
        </Layout>
    )
}
export default StylesheetColors;